/**
 * **按口碑分档**的公共判定（2026-10-22）。
 *
 * 一处实现、两处复用：`PlotSystem` 掷触发概率、`MediaPanel` 选评论档 ⇒ 两者永远取同一档，
 * 不会出现"概率按低档算、评论却按高档显"的分叉。
 *
 * 规则：在一张档位表里取**当前口碑命中的最紧一档**（`maxRep` 最小且 ≥ 当前口碑的那个）；
 * 一档都没命中 ⇒ undefined（调用方各自落回默认）。
 * 档位表的 `maxRep` 应当**互不重叠**（读表哨兵有一道门拦这个）。
 */
import type { RepBand } from '../data/types';

/**
 * 取当前口碑命中的那一档（最紧的一档）。
 * @param bands 档位表（`maxRep` 递增或递减都无所谓，判定与书写顺序无关）
 * @param reputation 当前口碑（运行时值，-500~500）
 */
export function bandOf<T extends RepBand>(bands: T[], reputation: number): T | undefined {
 let hit: T | undefined;
 for (const b of bands) {
 if (reputation > b.maxRep) continue; // 这一档管不到当前口碑
 if (!hit || b.maxRep < hit.maxRep) hit = b; // 取"管得到"里最紧的一档
 }
 return hit;
}
